/**
 * Configuration Constants
 *
 * Application-wide configuration values
 */

/**
 * Feature Flags
 *
 * Control visibility and availability of features in the application.
 * To enable/disable a feature, simply change the boolean value.
 * Note: All backend and frontend code remains intact when features are disabled.
 */
export const FEATURE_FLAGS = {
  /**
   * CU Marketplace Bot
   * Controls whether the marketplace bot is accessible in the UI.
   * When false: The /cu-marketplace route will not be registered (users see 404)
   * When true: The marketplace bot is accessible at /cu-marketplace
   *
   * To enable: Change this value to true
   * To disable: Change this value to false
   */
  ENABLE_MARKETPLACE: false,
} as const;
